import { APP_V2_USER_EVENTS, logEvent } from "../lib/analytics";
import { type WorkerInvitationAction, type WorkerInvitationOpenedFrom } from "./types";

export function sendWorkerInvitationDialogActionedEvent(params: {
  workplaceId: string;
  isAdmin: boolean;
  openedFrom: WorkerInvitationOpenedFrom;
  action: WorkerInvitationAction;
}) {
  const { workplaceId, isAdmin, openedFrom, action } = params;

  logEvent(APP_V2_USER_EVENTS.WORKER_INVITATION_DIALOG_ACTIONED, {
    workplaceId,
    isAdmin,
    openedFrom,
    action,
  });
}
